export const RESTORE_CODE_SENDED = "Restore code was sent to your email";
export const PASSWORD_CHANGED = "Password successfully changed";
